import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-column gap-2" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["id"]

import { toRef, watch } from 'vue';
import { useField } from 'vee-validate';
import InputNumber from 'primevue/inputnumber';
import { Nullable } from 'primevue/ts-helpers';

const __default__ = {
    inheritAttrs: false
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InputNumberWithLabel',
  props: {
    name: {},
    label: {},
    modelValue: {},
    type: { default: 'text' },
    smallLabel: {}
  },
  setup(__props: any) {

const props = __props;


const { errorMessage, value } = useField<Nullable<number>>(toRef(props, 'name'), undefined, {
    initialValue: props.modelValue
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", { for: _ctx.name }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.smallLabel)
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.smallLabel), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createVNode(_unref(InputNumber), _mergeProps({
      id: _ctx.name,
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
    }, _ctx.$attrs, {
      mode: "decimal",
      locale: "en-US",
      "min-fraction-digits": 0,
      "max-fraction-digits": 2,
      type: _ctx.type,
      class: { 'p-invalid': _unref(errorMessage) },
      "aria-describedby": `${_ctx.name}-help`
    }), null, 16, ["id", "modelValue", "type", "class", "aria-describedby"]),
    _createElementVNode("div", null, [
      _createElementVNode("small", {
        id: `${_ctx.name}-help`,
        class: "p-error"
      }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_4)
    ])
  ]))
}
}

})